<div class="container m-auto px-4 text-center">
  <h1>404</h1>
  <a href="/">Página no encontrada, ir al inicio.</a>
</div>
